import { LoggerEnum } from "@/enums";
import { INotSure } from "@/types";

class AppLogger {
  private static log(
    level: LoggerEnum,
    message: string,
    ...optionalParams: INotSure[]
  ) {
    const timestamp = new Date().toISOString();
    switch (level) {
      case LoggerEnum.INFO:
        console.info(`[INFO] [${timestamp}] -> ${message}`, ...optionalParams);
        break;
      case LoggerEnum.WARN:
        console.warn(`[WARN] [${timestamp}] -> ${message}`, ...optionalParams);
        break;
      case LoggerEnum.ERROR:
        console.error(
          `[ERROR] [${timestamp}] -> ${message}`,
          ...optionalParams
        );
        break;
      case LoggerEnum.DEBUG:
        console.debug(
          `[DEBUG] [${timestamp}] -> ${message}`,
          ...optionalParams
        );
        break;
    }
  }

  static info(message: string, ...optionalParams: INotSure[]) {
    this.log(LoggerEnum.INFO, message, ...optionalParams);
  }

  static warn(message: string, ...optionalParams: INotSure[]) {
    this.log(LoggerEnum.WARN, message, ...optionalParams);
  }

  static error(message: string, ...optionalParams: INotSure[]) {
    this.log(LoggerEnum.ERROR, message, ...optionalParams);
  }

  static debug(message: string, ...optionalParams: INotSure[]) {
    this.log(LoggerEnum.DEBUG, message, ...optionalParams);
  }
}

export default AppLogger;
